<div class="topbar">
    <nav class="navbar-custom">
        <ul class="list-unstyled topbar-nav mb-0">
            <li>
                <button onclick="tooglemenu()" class="navbar-toggle ml-3" data-toggle="collapse" id="menu-toggle-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="align-self-center topbar-icon">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>
            </li>
        </ul>
        <ul class="list-unstyled topbar-nav float-right mb-0 row" style="padding-right: 10px;">
            <li>
                <div>
                    <!-- <select class="form-control" #Year="ngModel" ngModel name="Year" id="yeardd"
                    (change)="ChangeYearDetails()">
                    <option *ngFor="let year of yearlist" value="{{year.value}}">{{year.text}} </option>>
                </select> #YearID="ngModel" [(ngModel)]="data.YearID"-->
                <select class="form-control" ngModel name="YearID" id="YearID" [(ngModel)]="YearID" (change)="ChangeYearDetails()" required>
                                <!-- <option *ngFor="let year of yearlist" [ngValue]="year.value" [selected]="data.YearID === year.value">
                                    {{year.text}}
                                </option> -->
                                <option *ngFor="let year of yearlist" value="{{year.value}}">{{year.text}}</option>
                            </select>
                    <!-- <p><span class="mr-2 nav-user-name hidden-sm" style="color: #364150;"><b>Year</b> : {{yearName}} &nbsp; &nbsp; {{username}}</span>
                    </p> -->
                </div>
            </li>
            <li style="padding-left: 10px;padding-top: 5px;">
                <div>
                    <p><strong><span class="mr-2 nav-user-name hidden-sm" style="color: #364150;">{{username}}</span></strong></p>
                </div>
            </li>
            <li class="dropdown">
                <a class="nav-link nav-user custom-logout" href="javascript:void(0);" role="button" onclick="profile()">
                    <div class="custom-logout-inner">
                        <img src="assets/images/NoUserImage.png" alt="profile-user" class="rounded-circle">
                    </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right custom-logout">
                    <a class="logout-btn" href="javascript:void(0);" (click)="ChangePassword();">
                        <i class="fas fa-key" style="size: 2px;" aria-hidden="true"></i>
                         &nbsp;Change password</a>
                    <a class="logout-btn" href="javascript:void(0);" (click)="Logout();">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="logout-icon mr-2">
                            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                            <line x1="12" y1="2" x2="12" y2="12"></line>
                        </svg> Logout</a>
                </div>
            </li>
        </ul>
    </nav>
</div>
<div class="modal fade" id="resetpassword" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false" style="top: 100px;">
    <div class="modal-dialog modal-lg-12">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Change Password</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="Close();">
                    &times;</button>
            </div>
            <div class="modal-body">
                <div class="container pt-35">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="center-block">
                                <div class="login-box">
                                    <div class="icon-box">
                                        <img src="assets/images/cap.png" class="img-fluid i_img">
                                    </div>
                                    <h4></h4>
                                    <!-- <img src="{{headerimage}}" class="img-fluid d-block mx-auto mt-35" style="width: 500px;"> -->
                                    <!-- <h5 class="mt-35" style="color: red;">Please refresh the page before change password</h5> -->
                                    <form #changePasswordForm="ngForm" (ngSubmit)="onSubmit()">
                                        <div class="form-group">
                                            <label>Old password</label><span class="text-danger">*</span>
                                            <input type="password" #oldPassword="ngModel" ngModel name="oldPassword"
                                                class="form-control" placeholder="Enter old password" required>
                                            <span *ngIf="changePasswordForm.submitted && oldPassword.invalid"
                                                id="divOldpassword">
                                                <p *ngIf="oldPassword.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Old password is required
                                                </p>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <label>New Password</label><span class="text-danger">*</span>
                                            <input type="password" #newPassword="ngModel" ngModel name="newPassword"
                                                class="form-control" placeholder="Enter new password" minlength="8"
                                                required>
                                            <span style="color: grey; font-weight: bold;">(Password must be atleast of 8
                                                character)</span>
                                            <span *ngIf="changePasswordForm.submitted && newPassword.invalid"
                                                id="divNewpassword">
                                                <p *ngIf="newPassword.errors.required" class="error_message"
                                                    style="color: red;">
                                                    New password is required
                                                </p>
                                                <p *ngIf="newPassword.errors.minlength" class="error_message"
                                                    style="color: red; ">
                                                    New password must be atleast of 8 character
                                                </p>
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <label>Confirm password</label><span class="text-danger">*</span>
                                            <input type="password" #confirmPassword="ngModel" ngModel
                                                name="confirmPassword" class="form-control"
                                                placeholder="Enter confirm password"
                                                appConfirmEqualValidator="newPassword" id="confirmPassword" required>
                                            <span style="color: grey; font-weight: bold;">(Password must be atleast of 8
                                                character)</span>
                                            <span *ngIf="changePasswordForm.submitted && confirmPassword.invalid"
                                                id="divConfirmpassword">
                                                <p *ngIf="confirmPassword.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Confirm password is required
                                                </p>
                                                <span class="help-block error_message" style="color: red;"
                                                    *ngIf="confirmPassword.touched && confirmPassword.errors?.notEqual && !confirmPassword.errors?.required">
                                                    Password and confirm password does not match
                                                </span>
                                            </span>
                                        </div>
                                        <div class="row mt-2">
                                            <button type="submit" class="btn btn-primary btn-block mt-3">Change
                                                password</button>
                                        </div>
                                    </form>
                                    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default"
                                        type="ball-spin-clockwise">
                                        <p style="color: white;">Please Wait.</p>
                                    </ngx-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<script type="text/javascript">
    $(document).ready(function () {

        $('[data-toggle="popover"]').popover()
    });
</script>